import { withInstall } from '../../utils';
import Select from './src/select.vue';

export const ISelect = withInstall(Select); // 增加类型

export default ISelect;
